export default "__VITE_ASSET__24e2020b__"